import React from 'react';
import { Box, Button, IconButton, TextField, FormControl, InputLabel, Grid, Select, Slider, MenuItem, Typography, Accordion, AccordionSummary, AccordionDetails, ButtonGroup } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormatAlignLeft, FormatAlignCenter, FormatAlignJustify, FormatAlignRight } from '@mui/icons-material';
import FormatSizeIcon from '@mui/icons-material/FormatSize';

function TypographyProps({ properties = {}, onPropertyChange }) {
  return (
    <Accordion sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          Typography
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel>Font Family</InputLabel>
            <Select
              value={properties.fontFamily || 'Arial, sans-serif'}
              onChange={(e) => onPropertyChange('fontFamily', e.target.value)}
              label="Font Family"
            >
              <MenuItem value="Arial, sans-serif">Arial</MenuItem>
              <MenuItem value="Georgia, serif">Georgia</MenuItem>
              <MenuItem value="'Times New Roman', serif">Times New Roman</MenuItem>
              <MenuItem value="'Courier New', monospace">Courier New</MenuItem>
              <MenuItem value="Helvetica, sans-serif">Helvetica</MenuItem>
              <MenuItem value="'Trebuchet MS', sans-serif">Trebuchet MS</MenuItem>
            </Select>
          </FormControl>

          <Box>
            <Typography variant="body2" gutterBottom>
              Font Size
            </Typography>
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid>
                <FormatSizeIcon />
              </Grid>
              <Grid size="grow">
                <Slider
                  value={properties.fontSize || 16}
                  onChange={(e, value) => onPropertyChange('fontSize', value)}
                  aria-labelledby="input-slider-font-size"
                  step={1}
                  marks
                  max={48}
                  min={10}
                />
              </Grid>
              <Grid>
                <Typography variant="body2" gutterBottom>
                  {properties.fontSize || 16} px
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <TextField
            label="Line Height"
            type="number"
            step="0.1"
            value={properties.lineHeight || 1.5}
            onChange={(e) => onPropertyChange('lineHeight', parseFloat(e.target.value) || 1.5)}
            fullWidth
            size="small"
            variant="outlined"
          />

          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Text Color
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <input
                type="color"
                value={properties.color || '#000000'}
                onChange={(e) => onPropertyChange('color', e.target.value)}
                style={{
                  width: 40,
                  height: 40,
                  border: '1px solid #ccc',
                  borderRadius: 4,
                  cursor: 'pointer'
                }}
              />
              <TextField
                value={properties.color || '#000000'}
                onChange={(e) => onPropertyChange('color', e.target.value)}
                size="small"
                variant="outlined"
                sx={{ flexGrow: 1 }}
              />
            </Box>
          </Box>

          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Font Weight
            </Typography>
            <ButtonGroup variant="outlined">
              <Button 
                onClick={() => onPropertyChange('fontWeight', 'normal')}
                variant={properties.fontWeight === 'normal' ? 'contained' : 'outlined'}
              >
                Normal
              </Button>
              <Button 
                onClick={() => onPropertyChange('fontWeight', 'bold')}
                variant={properties.fontWeight === 'bold' ? 'contained' : 'outlined'}
              >
                Bold
              </Button>
              <Button 
                onClick={() => onPropertyChange('fontWeight', 'lighter')}
                variant={properties.fontWeight === 'lighter' ? 'contained' : 'outlined'}
              >
                Light
              </Button>
            </ButtonGroup>
          </Box>

          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Text Alignment
            </Typography>
            <Box>
              <IconButton 
                onClick={() => onPropertyChange('textAlign', 'left')}
                color={properties.textAlign === 'left' ? 'primary' : 'default'}
              >
                <FormatAlignLeft />
              </IconButton>
              <IconButton 
                onClick={() => onPropertyChange('textAlign', 'center')}
                color={properties.textAlign === 'center' ? 'primary' : 'default'}
              >
                <FormatAlignCenter />
              </IconButton>
              <IconButton 
                onClick={() => onPropertyChange('textAlign', 'right')}
                color={properties.textAlign === 'right' ? 'primary' : 'default'}
              >
                <FormatAlignRight />
              </IconButton>
              <IconButton 
                onClick={() => onPropertyChange('textAlign', 'justify')}
                color={properties.textAlign === 'justify' ? 'primary' : 'default'}
              >
                <FormatAlignJustify />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default TypographyProps;